import { Link } from "react-router-dom";
import "./Book.css";
import { IoMdArrowBack } from "react-icons/io";
import sedan from "../../images/corola1.png";
import { useRecoilState } from "recoil";
import photoState from "../../components/atoms/photo.atom";
import Sedan from "../../components/gallery/Sedan";
import Suv from "../../components/gallery/Suv";
import Grand from "../../components/gallery/Grand";
import Mini from "../../components/gallery/Mini";
import Van from "../../components/gallery/Van";
import Coaster from "../../components/gallery/Coaster";
import { useEffect, useState } from "react";
import timeState from "../../components/atoms/goTime";
import { IoIosArrowForward } from "react-icons/io";
import suv from "../../images/suv3.png";
import grand from "../../images/grand.webp";
import h1 from "../../images/download.png";
import his from "../../images/b2.png";
import coaster from "../../images/coaster1.png";
import { MdDone } from "react-icons/md";
import backTimeState from "../../components/atoms/backTime.atom";
import { format, parseISO } from "date-fns";
import nameState from "../../components/atoms/Name";
import emailState from "../../components/atoms/Email";
import phoneState from "../../components/atoms/Phone";
import voda from "../../images/vodafone.webp";
import insta from "../../images/pay.png";
import cash from "../../images/cash2548.jpg";
import cashState from "../../components/atoms/Cash.atom";
import photoTwoState from "../../components/atoms/PhotoTwo.atom";
import photoThreeState from "../../components/atoms/PhotoThree.atom";
import photoFourState from "../../components/atoms/PhotoFour.atom";
import photoFiveState from "../../components/atoms/PhotoFive.atom";
import photoSixState from "../../components/atoms/PhotoSix.atom";

import Swal from "sweetalert2";

function Book() {
  const type = localStorage.getItem("type");
  const price = localStorage.getItem("price");
  const [show, setShow] = useRecoilState(photoState);
  const [showTwo, setShowTwo] = useRecoilState(photoTwoState);
  const [showThree, setShowThree] = useRecoilState(photoThreeState);
  const [showFour, setShowFour] = useRecoilState(photoFourState);
  const [showFive, setShowFive] = useRecoilState(photoFiveState);
  const [showSix, setShowSix] = useRecoilState(photoSixState);
  const travel = localStorage.getItem("pickup");
  const destination = localStorage.getItem("arrival");
  const goDate = localStorage.getItem("pickupDate");
  const backDate = localStorage.getItem("returnDate");
  const [time, setTime] = useRecoilState(timeState);
  const [backTime, setBackTime] = useRecoilState(backTimeState);
  const arrival = localStorage.getItem("arrivalInp");
  localStorage.setItem("goTime", time);
  localStorage.setItem("backTime", backTime);
  const goTime = localStorage.getItem("goTime");
  const backTimes = localStorage.getItem("backTime");
  const car = localStorage.getItem("car");
  const go = localStorage.getItem("pickupInp");
  const [num, setNum] = useState(1);
  const [trip, setTrip] = useState(1);
  const [name, setName] = useRecoilState(nameState);
  const [mail, setMail] = useRecoilState(emailState);
  const [mobile, setMobile] = useRecoilState(phoneState);
  const [pays, setPays] = useRecoilState(cashState);

  localStorage.setItem("name", name);
  localStorage.setItem("email", mail);
  localStorage.setItem("phone", mobile);
  localStorage.setItem("cash", pays);

  const userName = localStorage.getItem("name");
  const Email = localStorage.getItem("email");
  const Mobile = localStorage.getItem("phone");
  const Cash = localStorage.getItem("cash");
  const [vodafon, setVoda] = useState(false);
  const [instapay, setInsta] = useState(false);
  const [cashs, setCash] = useState(false);

  const dateStr = goDate;
  const dateStrs = backDate;
  const date = parseISO(dateStr);
  const dates = parseISO(dateStrs);

  // الحصول على اسم اليوم
  const dayName = format(date, "EEEE");
  const dayNames = format(dates, "EEEE");
  const formattedDate = format(dates, "d MMM yyyy");
  const formattedBDate = format(date, "d MMM yyyy");

  const defaultDate = new Date(goDate);
  const defaultBDate = new Date(backDate);

  // تحويل التاريخ إلى الصيغة المناسبة لـ input date
  const FormatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // الأشهر تبدأ من 0
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const [currentTime, setCurrentTime] = useState(getCurrentTime());

  useEffect(() => {
    // تحديث الوقت كل دقيقة
    const interval = setInterval(() => {
      setCurrentTime(getCurrentTime());
    }, 60000);

    // تنظيف المؤقت عند فك تحميل المكون
    return () => clearInterval(interval);
  }, []);

  const [selectedDate, setSelectedDate] = useState(FormatDate(defaultDate));
  const [selectedBDate, setSelectedBDate] = useState(FormatDate(defaultBDate));

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // لعمل تمرير سلس
    });
  };

  function CarType({ vehicle }) {
    if (vehicle === "sedan") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={sedan} alt="car" />
                </div>
                <div className="title">
                  <h3>{car}</h3>
                  <div className="below">
                    <span>
                      Toyota, Elentra ,Kia & Similar Starting From 2021
                    </span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{price}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">3 seats</li>
                <li className="bag">1 Large Bag + 1 Small Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShow(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    } else if (vehicle === "suv") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={suv} className="suv" alt="car" />
                </div>
                <div className="title">
                  <h3>{car}</h3>
                  <div className="below">
                    <span>
                      Tucson, Sportage ,MG zs & Similar Starting From 2021
                    </span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{+price + 500}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">4 seats</li>
                <li className="bag">3 Large Bag + 2 Small Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShowTwo(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    } else if (vehicle === "grand") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={grand} alt="car" />
                </div>
                <div className="title">
                  <h3>suv {car}</h3>
                  <div className="below">
                    <span>
                      Xpander, Glory ,Ortega & Similar Starting From 2021
                    </span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{+price + 1000}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">6 seats</li>
                <li className="bag">3 Large Bag + 2 Small Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShowThree(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    } else if (vehicle === "mini") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={h1} alt="car" />
                </div>
                <div className="title">
                  <h3> {car} van</h3>
                  <div className="below">
                    <span>Hyundai H1 Starting From 2020</span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{+price + 1500}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">From 7 to 9 Seats</li>
                <li className="bag">6 Large Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShowFour(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    } else if (vehicle === "van") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={his} alt="car" />
                </div>
                <div className="title">
                  <h3> {car}</h3>
                  <div className="below">
                    <span>Toyota HIAS Starting From 2022</span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{+price + 2000}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">13 seats</li>
                <li className="bag">13 Large Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShowFive(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    } else if (vehicle === "coaster") {
      return (
        <div className="info">
          <div className="types">
            <div className="one">
              <div className="left">
                <div className="image">
                  <img src={coaster} alt="car" />
                </div>
                <div className="title">
                  <h3> {car}</h3>
                  <div className="below">
                    <span>Toyota Coaster Starting From 2020</span>
                    <Link to={"/details"}>Change Limousine</Link>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="price">
                  <span>{type} Trip Price</span>
                  <p>
                    <span>{+price + 2500}</span> EGP
                  </p>
                </div>
              </div>
            </div>
            <div className="two">
              <ul className="d-flex p-0 m-0">
                <li className="seats">From 22 To 24 Seats</li>
                <li className="bag">24 Large Bag</li>
              </ul>
              <div
                className="gallery"
                onClick={() => {
                  setShowSix(true);
                }}>
                Vehicle Gallery
              </div>
            </div>
            <div className="three">
              <div className="go d-flex">
                <p>{travel}</p>
                <span className="arrow"></span>
                <p>{destination}</p>
              </div>
            </div>
            <div className="four">
              <p>Free cancellation up to 24 hours before your pick-up</p>
            </div>
          </div>
        </div>
      );
    }
  }

  function Steps({ step }) {
    if (step === 1) {
      return (
        <ul className="numbers d-flex justify-content-center m-0 p-0">
          <li className="num active">
            <p>1</p>
            <span>First trip</span>
          </li>
          {type === "Round" ? (
            <>
              <li className="space"></li>
              <li className="num ">
                <p>2</p>
                <span>Second trip</span>
              </li>
            </>
          ) : null}
          <li className="space"></li>
          <li className="num ">
            <p>{type === "Round" ? 3 : 2}</p>
            <span>Passenger Details</span>
          </li>
          <li className="space"></li>
          <li className="num ">
            <p>{type === "Round" ? 4 : 3}</p>
            <span>Payment</span>
          </li>
        </ul>
      );
    } else if (step === 2) {
      return (
        <ul className="numbers d-flex justify-content-center m-0 p-0">
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>First trip</span>
          </li>
          {type === "Round" ? (
            <>
              <li className="space"></li>
              <li className="num active">
                <p>2</p>
                <span>Second trip</span>
              </li>
            </>
          ) : null}

          <li className="space"></li>
          <li className={type === "One Way" ? "num active" : "num"}>
            <p>{type === "Round" ? 3 : 2}</p>
            <span>Passenger Details</span>
          </li>

          <li className="space"></li>
          <li className="num ">
            <p>{type === "Round" ? 4 : 3}</p>
            <span>Payment</span>
          </li>
        </ul>
      );
    } else if (step === 3) {
      return (
        <ul className="numbers d-flex justify-content-center m-0 p-0">
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>First trip</span>
          </li>
          {type === "Round" ? (
            <>
              <li className="space"></li>
              <li className="num success">
                <p>
                  <MdDone />
                </p>
                <span>Second trip</span>
              </li>
            </>
          ) : null}
          <li className="space"></li>
          <li className="num active">
            <p>{type === "Round" ? 3 : 2}</p>
            <span>Passenger Details</span>
          </li>
          <li className="space"></li>
          <li className="num ">
            <p>{type === "Round" ? 4 : 3}</p>
            <span>Payment</span>
          </li>
        </ul>
      );
    } else if (step === 4) {
      return (
        <ul className="numbers d-flex justify-content-center m-0 p-0">
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>First trip</span>
          </li>
          {type === "Round" ? (
            <>
              <li className="space"></li>
              <li className="num success">
                <p>
                  <MdDone />
                </p>
                <span>Second trip</span>
              </li>
            </>
          ) : null}
          <li className="space"></li>
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>Passenger Details</span>
          </li>
          <li className="space"></li>
          <li className="num active">
            <p>{type === "Round" ? 4 : 3}</p>
            <span>Payment</span>
          </li>
        </ul>
      );
    } else if (step === 5) {
      return (
        <ul className="numbers d-flex justify-content-center m-0 p-0">
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>First trip</span>
          </li>
          {type === "Round" ? (
            <>
              <li className="space"></li>
              <li className="num success">
                <p>
                  <MdDone />
                </p>
                <span>Second trip</span>
              </li>
            </>
          ) : null}
          <li className="space"></li>
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>Passenger Details</span>
          </li>
          <li className="space"></li>
          <li className="num success">
            <p>
              <MdDone />
            </p>
            <span>Payment</span>
          </li>
        </ul>
      );
    }
  }

  function Total({ carType, type }) {
    if (carType === "sedan") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{price / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{price / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{price} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    } else if (carType === "suv") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 500) / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 500) / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{+price + 500} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    } else if (carType === "grand") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 1000) / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 1000) / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{+price + 1000} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    } else if (carType === "mini") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 1500) / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 1500) / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{+price + 1500} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    } else if (carType === "van") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 2000) / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 2000) / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{+price + 2000} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    } else if (carType === "coaster") {
      return (
        <>
          {type === "Round" ? (
            <>
              <div className="price">
                <div className="type">
                  <span>First Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 2500) / 2} </span>EGP
                  </p>
                </div>
              </div>
              <div className="price">
                <div className="type">
                  <span>Second Trip Price</span>
                </div>
                <div className="total">
                  <p>
                    <span>{(+price + 2500) / 2} </span>EGP
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="price">
            <div className="type">
              <span>Total Price</span>
            </div>
            <div className="total">
              <p>
                <span>{+price + 2500} </span>EGP
              </p>
            </div>
          </div>
        </>
      );
    }
  }

  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handlePhoneChange = (e) => {
    const phoneInput = e.target.value;
    setPhone(phoneInput);

    const egyptianPhoneRegex = /^(?:\+20|01)\d{9}$/;

    if (!egyptianPhoneRegex.test(phoneInput)) {
      setError("please enter right phone number");
    } else {
      setError("");
    }
  };

  //  const [image, setImage] = useState(null);
  //  const handleFileChange = (e) => {
  //         setImage(e.target.files[0]); // الحصول على الملف من input
  //     };

  //  const [file, setFile] = useState(null);

  //   const handleFileChange = (event) => {
  //     setFile(event.target.files[0]);
  //   };

  //   const handleUpload = async () => {
  //     const formData = new FormData();
  //     formData.append('file', file);

  //     try {
  //       const response = await axios.post('http://localhost:4000/upload', formData);
  //       const { filename } = response.data;
  //       // تعيين عنوان URL للصورة
  //       setImage(`http://localhost:4000/uploads/${filename}`);
  //     } catch (error) {
  //       console.error('Error uploading file:', error);
  //     }
  //   };

  // console.log(image);

  // const formData = new FormData();
  // formData.append('startLocation', go);
  // formData.append('startCity', travel);
  //     formData.append('endLocation', arrival);
  //     formData.append('endCity', destination);
  //     formData.append('packupDate', goDate);
  //     formData.append('returnDate', backDate);
  //     formData.append('type', type);
  //     formData.append('carType', car);
  //     formData.append('Price', price);
  //     formData.append('pickupTime', goTime);
  //     formData.append('returnTime', backTime);
  //     formData.append('Cash', Cash);
  //     formData.append('Name', userName);
  //     formData.append('Email', Email);
  //     formData.append('Phone', Mobile);

  function SendPrice({ type, price }) {
    if (type === "sedan") {
      return localStorage.setItem("money", price);
    } else if (type === "suv") {
      return localStorage.setItem("money", +price + 500);
    } else if (type === "grand") {
      return localStorage.setItem("money", +price + 1000);
    } else if (type === "mini") {
      return localStorage.setItem("money", +price + 1500);
    } else if (type === "van") {
      return localStorage.setItem("money", +price + 2000);
    } else if (type === "coaster") {
      return localStorage.setItem("money", +price + 2500);
    }
  }

  const money = localStorage.getItem("money");

  const showAlert = () => {
    Swal.fire({
      title: "Success",
      text: "Your trip has been successfully booked",
      icon: "success",
      confirmButtonText: "Ok",
    });
  };
  const showAlerts = (word) => {
    Swal.fire({
      title: "Error",
      text: word,
      icon: "error",
      confirmButtonText: "Ok",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    showAlert();
  };

  return (
    <>
      <SendPrice type={car} price={price} />
      <div className="books">
        <div className="steps">
          <div className="grid">
            <div
              className={
                trip === 3 || trip === 4 ? "content three" : "content"
              }>
              <div className="top">
                <Steps step={num} />
                <div className="detail">
                  <div className="title">
                    <h1>Complete Your Booking</h1>
                    <p>{type} Trip Travel Limousine Transfer</p>
                  </div>
                </div>
              </div>
              <div className="forms">
                <div className="back">
                  <Link to={"/details"}>
                    <IoMdArrowBack size={"20px"} className="me-1" />
                    Go Back
                  </Link>
                </div>
                <CarType vehicle={car} />
                {trip === 1 ? (
                  <div className="first">
                    <div className="text">
                      <div className="title">
                        <h3>First Trip Details</h3>
                      </div>
                      <div className="pickup">
                        <p className="location">Pick Up Details</p>
                        <form>
                          <div className="date pb-5">
                            <div className="custom">
                              <div className="go-date">
                                <label htmlFor="date">
                                  Confirm Pickup Date
                                </label>
                                <input
                                  name="date"
                                  type="date"
                                  value={selectedDate}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="time position-relative">
                                <div className="label">
                                  <label htmlFor="time">Pickup Time</label>
                                </div>
                                <input
                                  type="time"
                                  name="time"
                                  defaultValue={currentTime}
                                  className="form-control"
                                  onChange={(e) => {
                                    setTime(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="address pb-5">
                            <div className="custom">
                              <div className="to">
                                <div className="label pb-4">
                                  <label htmlFor="to">
                                    Address In {travel}
                                  </label>
                                </div>
                                <div className="box d-flex justify-content-between">
                                  <div className="two w-100">
                                    <label htmlFor="city">Street Name *</label>
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      className=" form-control"
                                      value={go + ", Egypt"}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className=" to too">
                                <div className="label pb-4">
                                  <label htmlFor="to">
                                    Address In {destination}
                                  </label>
                                </div>
                                <div className="box d-flex justify-content-between">
                                  <div className="two w-100">
                                    <label htmlFor="city">Street Name *</label>
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      className=" form-control"
                                      value={arrival + ", Egypt"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="button d-flex justify-content-end">
                      <button
                        className="btn "
                        onClick={() => {
                          setNum(2);
                          type === "Round" ? setTrip(2) : setTrip(3);
                          scrollToTop();
                        }}>
                        Next <IoIosArrowForward size={"25px"} />
                      </button>
                    </div>
                  </div>
                ) : null}

                {trip === 2 && type === "Round" ? (
                  <div className="first">
                    <div className="text">
                      <div className="title">
                        <h3>Second Trip Details</h3>
                      </div>
                      <div className="pickup">
                        <p className="location">Pick Up Details</p>
                        <form>
                          <div className="date pb-5">
                            <div className="custom">
                              <div className="go-date">
                                <label htmlFor="date">
                                  Confirm Pickup Date
                                </label>
                                <input
                                  name="date"
                                  type="date"
                                  value={selectedBDate}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                              <div className="time position-relative">
                                <div className="label">
                                  <label htmlFor="time">Pickup Time</label>
                                </div>
                                <input
                                  type="time"
                                  name="time"
                                  defaultValue={currentTime}
                                  className="form-control"
                                  onChange={(e) => {
                                    setBackTime(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="address pb-5">
                            <div className="custom">
                              <div className="to">
                                <div className="label pb-4">
                                  <label htmlFor="to">
                                    Address In {destination}
                                  </label>
                                </div>
                                <div className="box d-flex justify-content-between">
                                  <div className="two w-100">
                                    <label htmlFor="city">Street Name *</label>
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      className=" form-control"
                                      value={arrival + ", Egypt"}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className=" to too">
                                <div className="label pb-4">
                                  <label htmlFor="to">
                                    Address In {travel}
                                  </label>
                                </div>
                                <div className="box d-flex justify-content-between">
                                  <div className="two w-100">
                                    <label htmlFor="city">Street Name *</label>
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      className=" form-control"
                                      value={go + ", Egypt"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="button d-flex justify-content-end">
                      <button
                        className="btn "
                        onClick={() => {
                          setNum(3);
                          setTrip(3);
                          scrollToTop();
                        }}>
                        Next <IoIosArrowForward size={"25px"} />
                      </button>
                    </div>
                  </div>
                ) : null}

                {trip === 3 ? (
                  <div className="third">
                    <div className="two">
                      <div className="left">
                        <div className="title">
                          <p className="mb-0">Booking Summary</p>
                        </div>
                        <div className="detial">
                          <div className="first-trip">
                            <div className="trip-title d-flex justify-content-between">
                              <p className="mb-0">First trip</p>
                              <Link to={"/"}>Change</Link>
                            </div>
                            <div className="pickup">
                              <p className="title mb-0">Travel From</p>
                              <div className="top d-flex">
                                <div className="location">
                                  <p className="mb-0">
                                    {go}-Egypt - {travel}
                                  </p>
                                </div>
                              </div>
                              <div className="bottom d-flex">
                                <div className="date">
                                  <p className="mb-0">
                                    {dayName} , {formattedBDate} , {goTime}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="arrival">
                              <p className="title mb-0">Travel To</p>
                              <div className="top d-flex">
                                <div className="location">
                                  <p className="mb-0">
                                    {arrival}-egypt - {destination}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {type === "Round" ? (
                            <div className="first-trip">
                              <div className="trip-title d-flex justify-content-between">
                                <p className="mb-0">Second trip</p>
                                <Link to={"/"}>Change</Link>
                              </div>
                              <div className="pickup">
                                <p className="title mb-0">Travel From</p>
                                <div className="top d-flex">
                                  <div className="location">
                                    <p className="mb-0">
                                      {arrival}-Egypt - {destination}
                                    </p>
                                  </div>
                                </div>
                                <div className="bottom d-flex">
                                  <div className="date">
                                    <p className="mb-0">
                                      {dayNames} , {formattedDate} , {backTimes}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="arrival">
                                <p className="title mb-0">Travel To</p>
                                <div className="top d-flex">
                                  <div className="location">
                                    <p className="mb-0">
                                      {go}-egypt - {travel}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <Total carType={car} type={type} />
                      </div>
                      <div className="right">
                        <div>
                          <p className="title mb-0">Booking Your Limousine</p>

                          <div className="account">
                            <p className="title mt-4 mb-0"> Book As A Guest</p>
                            <form>
                              <div className="inp">
                                <label htmlFor="name">Full Name *</label>
                                <input
                                  type="text"
                                  name="name"
                                  required
                                  onChange={(e) => {
                                    setName(e.target.value);
                                  }}
                                />
                              </div>
                              <div className="inp">
                                <label htmlFor="mail">Email Address *</label>
                                <input
                                  type="text"
                                  name="mail"
                                  required
                                  onChange={(e) => {
                                    setMail(e.target.value);
                                  }}
                                />
                              </div>
                              <div className="inp">
                                <label htmlFor="phone">Mobile Number *</label>
                                <input
                                  type="text"
                                  name="phone"
                                  required
                                  onChange={(e) => {
                                    handlePhoneChange(e);
                                    setMobile(e.target.value);
                                  }}
                                  placeholder="+20"
                                />
                                {error && (
                                  <p style={{ color: "red" }}>{error}</p>
                                )}
                              </div>
                              <div className="button next d-flex justify-content-end">
                                <button
                                  className="btn "
                                  onClick={() => {
                                    setNum(4);
                                    setTrip(4);
                                    scrollToTop();
                                  }}>
                                  Next{" "}
                                  <IoIosArrowForward
                                    className="arrow"
                                    size={"25px"}
                                  />
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {trip === 4 ? (
                  <div className="third">
                    <div className="two">
                      <div className="left">
                        <div className="title">
                          <p className="mb-0">Booking Summary</p>
                        </div>
                        <div className="detial">
                          <div className="first-trip">
                            <div className="trip-title d-flex justify-content-between">
                              <p className="mb-0">First trip</p>
                              <Link to={"/"}>Change</Link>
                            </div>
                            <div className="pickup">
                              <p className="title mb-0">Travel From</p>
                              <div className="top d-flex">
                                <div className="location">
                                  <p className="mb-0">
                                    {go}-Egypt - {travel}
                                  </p>
                                </div>
                              </div>
                              <div className="bottom d-flex">
                                <div className="date">
                                  <p className="mb-0">
                                    {dayName} , {goDate} , {goTime}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="arrival">
                              <p className="title mb-0">Travel To</p>
                              <div className="top d-flex">
                                <div className="location">
                                  <p className="mb-0">
                                    {arrival}-egypt - {destination}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {type === "Round" ? (
                            <div className="first-trip">
                              <div className="trip-title d-flex justify-content-between">
                                <p className="mb-0">Second trip</p>
                                <Link to={"/"}>Change</Link>
                              </div>
                              <div className="pickup">
                                <p className="title mb-0">Travel From</p>
                                <div className="top d-flex">
                                  <div className="location">
                                    <p className="mb-0">
                                      {arrival}-Egypt - {destination}
                                    </p>
                                  </div>
                                </div>
                                <div className="bottom d-flex">
                                  <div className="date">
                                    <p className="mb-0">
                                      {dayNames} , {formattedDate} , {backTimes}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="arrival">
                                <p className="title mb-0">Travel To</p>
                                <div className="top d-flex">
                                  <div className="location">
                                    <p className="mb-0">
                                      {go}-egypt - {travel}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <Total carType={car} type={type} />
                      </div>
                      <div className="here">
                        <div className="info">
                          <div className="your">
                            <div className="title">
                              <p>Your info</p>
                              <span
                                onClick={() => {
                                  setTrip(3);
                                }}>
                                Edit your info
                              </span>
                            </div>
                            <div className="content">
                              <p className="name">{userName}</p>
                              <p className="email">{Email}</p>
                              <p className="phone">{Mobile}</p>
                            </div>
                          </div>
                        </div>
                        <div className="payment">
                          <div>
                            <div className="title">
                              <p>Payment Information</p>
                            </div>
                            <p className="choose">Choose one of them</p>
                            <div className="pay">
                              <div
                                className="vodafon"
                                onClick={() => {
                                  setVoda(!vodafon);
                                  setInsta(false);
                                  setCash(false);
                                  setPays("vodafon cash");
                                }}>
                                <img src={voda} alt="vodafone" />
                                <p>Vodafone Cash</p>
                              </div>
                              <div
                                className="insta"
                                onClick={() => {
                                  setInsta(!instapay);
                                  setCash(false);
                                  setVoda(false);
                                  setPays("instapay");
                                }}>
                                <img src={insta} alt="insta" />
                                <p>Instapay</p>
                              </div>
                              <div
                                className="cash"
                                onClick={() => {
                                  setCash(!cashs);
                                  setVoda(false);
                                  setInsta(false);
                                  setPays("cash");
                                }}>
                                <img src={cash} alt="cash" />
                                <p>Cash</p>
                              </div>
                            </div>
                            <div className={vodafon ? "final" : "final none"}>
                              <p>
                                Send money to this number{" "}
                                <span>01032990092</span>
                              </p>
                              <p>Upload screenshot of the conversion</p>
                              <input type="file" className=" form-control" />
                              <div className="button next d-flex justify-content-end">
                                <button className="btn ">
                                  Next{" "}
                                  <IoIosArrowForward
                                    className="arrow"
                                    size={"25px"}
                                  />
                                </button>
                              </div>
                            </div>
                            <div className={instapay ? "final" : "final none"}>
                              <p>
                                Send money to this account{" "}
                                <span>35843579546876865</span>
                              </p>
                              <p>Upload screenshot of the conversion</p>
                              <input type="file" className=" form-control" />
                              <div className="button next d-flex justify-content-end">
                                <button className="btn ">
                                  Next{" "}
                                  <IoIosArrowForward
                                    className="arrow"
                                    size={"25px"}
                                  />
                                </button>
                              </div>
                            </div>
                            <div className={cashs ? "final" : "final none"}>
                              <p>
                                Well the money is paid to the driver on the day
                                of the trip
                              </p>
                              <div className="button next d-flex justify-content-end">
                                <button
                                  className="btn "
                                  onClick={() => {
                                    setNum(5);
                                    setTrip(5);
                                    scrollToTop();
                                  }}>
                                  Next{" "}
                                  <IoIosArrowForward
                                    className="arrow"
                                    size={"25px"}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {trip === 5 ? (
                  <div className="five">
                    <form onSubmit={handleSubmit}>
                      <div className="button next d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn "
                          onClick={() => {
                            setNum(5);
                            setTrip(5);
                            scrollToTop();
                          }}>
                          Confirm{" "}
                          <IoIosArrowForward className="arrow" size={"25px"} />
                        </button>
                      </div>
                    </form>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {show ? <Sedan /> : null}
      {showTwo ? <Suv /> : null}
      {showThree ? <Grand /> : null}
      {showFour ? <Mini /> : null}
      {showFive ? <Van /> : null}
      {showSix ? <Coaster /> : null}
    </>
  );
}

export default Book;
